










































import Vue from "vue";
import { Component } from "nuxt-property-decorator";
import { faTimes, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import BaseLoader from "~/components/core/BaseLoader.vue";
import { wait } from "~/shared";

@Component({
  name: "PaymentSuccessModal",
  components: { BaseLoader },
})
export default class PaymentSuccessModal extends Vue {
  get faTimes() {
    return faTimes;
  }

  get faAngleRight() {
    return faAngleRight;
  }

  get isAuth() {
    return this.$store.getters.isAuth as boolean;
  }

  get isPremium() {
    return (this.$store.getters.isPremium ||
      this.$store.getters.isUnlimited ||
      this.$store.getters.isPremiumV2 ||
      this.$store.getters.isLifelong) as boolean;
  }

  get isOpen() {
    return (
      process.browser && window && window.location.hash === "#payment-success"
    );
  }

  mounted() {
    setTimeout(() => {
      this.waitForPayment();
    }, 2000);
  }

  async waitForPayment() {
    let counter = 1;

    while (counter <= 300) {
      if (this.isPremium || !this.isAuth || !this.isOpen) return;
      await this.$store.dispatch("fetchUser");
      counter++;
      await wait(1000);
    }
  }

  onClose() {
    if (process.browser && window) {
      window.location.hash = "";
      this.$emit("close");
    }
  }
}
